<h4 class="mb-2">Papeis atribuidos ao "{{usuario.nome}}"</h4>

<kendo-grid
  [kendoGridBinding]="papeis"
  [loading]="carregando" [height]="500">
  <ng-template kendoGridToolbarTemplate [position]="'top'">
  </ng-template>
  <kendo-grid-messages
    pagerPage="Página"
    pagerOf="de"
    pagerItems="itens"
    noRecords="Nenhum papel da empresa encontrado "
    loading="Carregando"
    pagerItemsPerPage="ítems por página"
  >
  </kendo-grid-messages>

  <kendo-grid-column    [width]="75"  >
    <ng-template kendoGridCellTemplate let-papel >
      {{papel.id}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Papel"   >
    <ng-template kendoGridCellTemplate let-papel  >
      <span class="text-blue"   ><b>{{papel.nome}}</b></span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column title="Operações">
    <ng-template kendoGridCellTemplate let-papel   >
      <p class="pb-0 mb-0 "  *ngFor="let operacao of  papel.operacoes; let i = index;"><b>       {{i + 1}} - {{operacao.nome }}</b></p>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column title="" [width]="100">
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-papel>

      <kendo-switch [(ngModel)]="papel.ativo" (ngModelChange)="alterouPapel(papel)"
                    [onLabel]="'Sim'"
                    [offLabel]="'Não'"></kendo-switch>
    </ng-template>
  </kendo-grid-command-column>

</kendo-grid>
